import { DetailPage } from "../../components/crud/DetailPage"
import { ListPage } from "../../components/crud/ListPage"
import { TextInput } from "../../components/forms/Inputs"
import { useTranslations } from "../../layers/Localization"

function TypeDePlainteFields({ item, set, tab }) {
    const t = useTranslations()
    return <>
        <TextInput label={t("Nom")} value={item.nom} onChange={set('nom')} required />
    </>
}

export function TypeDePlaintesList(props) {
    const t = useTranslations()
    return <ListPage model="typeDePlaintes" title={t("Types de plaintes")} columns={{
        [t('Nom')]: 'nom',
    }} {...props} />
}

export function TypeDePlainteDetail(props) {
    const t = useTranslations()
    return <DetailPage model="typeDePlaintes" title={t("Type de plaintes")} Fields={TypeDePlainteFields} {...props} />
}
